import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/double-down-arrow-01-16.png'
import _imports_1 from '@/assets/main_adress.png'


const _withScopeId = n => (_pushScopeId("data-v-72d83091"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "carousel" }, null, -1))
const _hoisted_2 = {
  class: "airplane",
  id: "slider"
}
const _hoisted_3 = {
  key: 0,
  class: "hero banner container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  playsinline: "",
  loop: "",
  muted: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "/api/public/hero-banner-video.mp4",
    type: "video/mp4"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title fadeout" }, "AI-based Digital Twin for Aviation MRO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#description" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "scroll-down" }, [
    /*#__PURE__*/_createTextVNode("Scroll Down"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "scroll-down"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "slides-group"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "main-img-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/aircraft/B737-800" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Try Demo +")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "description" }, null, -1))
const _hoisted_16 = { class: "description" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "AK Corp. Aviation MRO Simulator", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We aim to innovate decades of legacy systems by integrating Artificial Intelligence (AI) and eXtended Reality (XR) technology. Our world's first ‘AI-based Digital Twin for Aviation MRO’ provides remote training and maintenance assistance and enhances the quality of training for aviation safety through an AI-powered maintenance manual navigation system via Cloud services. ", -1))
const _hoisted_19 = { class: "video-cards" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "video-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-hover" }, [
  /*#__PURE__*/_createTextVNode(" Main Landing Gear – MR version"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(Hololense II) ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "/api/public/Main-Landing-Gear-MR.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "video-wrap" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-hover" }, [
  /*#__PURE__*/_createTextVNode(" PowerPlant – VR version"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(Oculus) ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "/api/public/Power-Plant-VR.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "video-wrap" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-hover" }, [
  /*#__PURE__*/_createTextVNode(" Frequent Tasks – Servo Fuel Heater"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("PC version ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "/api/public/Frequent-Task-PC.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<h3 data-v-72d83091>Features</h3><ul class=\"features\" data-v-72d83091><li data-v-72d83091>Customizable : We develop and deliver 3D model of your own products along with the training manuals.</li><li data-v-72d83091>Compatible : The interactive contents are created and compatible with diverse devices such as smartphone, PC, tablet, laptop, web, and/or XR(VR, MR, AR) wearable glasses.</li><li data-v-72d83091>Cloud-based service: Use AK VIEW and share your screen through any online meeting platform for your remote training and online conference.</li><li data-v-72d83091>Confidentiality: Install our XR simulator in your server to secure your classified data. (On-premise service) </li><li data-v-72d83091>Commercial / Defense : Please <a href=\"/contact\" data-v-72d83091>contact us</a> for any inquiries regarding commercial/defense off-set trade.</li></ul><p data-v-72d83091>Experience our Cloud-based web content by clicking <a href=\"/aircrafts\" data-v-72d83091>‘Aircrafts’</a>.</p><div class=\"main-adress\" data-v-72d83091><a href=\"/pricing\" class=\"main-adress-btn\" data-v-72d83091><span data-v-72d83091>Pricing</span><img src=\"" + _imports_1 + "\" alt=\"\" data-v-72d83091></a><a href=\"/contact\" class=\"main-adress-btn\" data-v-72d83091><span data-v-72d83091>Contact</span><img src=\"" + _imports_1 + "\" alt=\"\" data-v-72d83091></a><a href=\"/api/public/brochure_eng_AK_eng.pdf\" class=\"main-adress-btn\" data-v-72d83091><span data-v-72d83091>Brochure</span><img src=\"" + _imports_1 + "\" alt=\"\" data-v-72d83091></a></div>", 4)

import { onMounted, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation, Scrollbar, Autoplay } from "swiper/modules";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Boeing737_800NG from "@/assets/Boeing737-800NG.png";
import Boeing737MAX from "@/assets/Boeing737-max.png";
import Airbus321Neo from "@/assets/Airbus321Neo.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const swiperModules = [Pagination, Navigation, Scrollbar, Autoplay];

const vid1 = ref<HTMLVideoElement | null>(null);
const vid2 = ref<HTMLVideoElement | null>(null);
const vid3 = ref<HTMLVideoElement | null>(null);

const smoothScroll = (event) => {
  event.preventDefault();
  const anchorId = event.currentTarget.getAttribute("href");
  const anchorElement = document.querySelector(`a[name='${anchorId.substring(1)}']`);
  if (anchorElement) {
    anchorElement.scrollIntoView({ behavior: "smooth" });
  }
};

onMounted(() => {
  [vid1, vid2, vid3].forEach((vid) => {
    if (vid.value) {
      const vidEl = vid.value;
      vidEl.muted = true;
      vidEl.play().catch(() => { });
    }
  });

  // Apply smooth scrolling to all anchor links
  const smoothScrollAnchors = document.querySelectorAll('a[href^="#"]');
  smoothScrollAnchors.forEach((anchor) => {
    anchor.addEventListener("click", smoothScroll);
  });
});

const container = ref<HTMLDivElement | null>(null);

const returnToTop = () => {
  container.value?.scrollTo(0, 0);
};

const slides = [
  { model: "hero" },
  {
    model: "Boeing 737-800 NG",
    description: "Boeing 737-800 NG",
    img: Boeing737_800NG,
    demoAvailable: true,
    link: "/aircraft/B737-800",
  },
  {
    model: "Boeing 737-MAX",
    description: "Boeing 737-MAX",
    img: Boeing737MAX,
    demoAvailable: false,
    link: "/aircraft/B737-MAX",
  },
  {
    model: "Airbus 321 Neo",
    description: "Airbus 321 Neo",
    img: Airbus321Neo,
    demoAvailable: false,
    link: "/aircraft/A321Neo",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    ref_key: "container",
    ref: container
  }, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(Swiper), {
        modules: swiperModules,
        "slides-per-view": 1,
        "space-between": 0,
        navigation: "",
        pagination: { clickable: true },
        speed: 500,
        "update-on-window-resize": "",
        autoplay: { delay: 15000, disableOnInteraction: false },
        scrollbar: { draggable: true },
        loop: true
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (card) => {
            return _createVNode(_unref(SwiperSlide), {
              key: card.model
            }, {
              default: _withCtx(() => [
                (card.model === 'hero')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_3, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("a", {
                        class: "slide-contents",
                        href: card.link
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h2", null, _toDisplayString(card.model), 1),
                          _createElementVNode("p", null, _toDisplayString(card.description), 1),
                          (card.demoAvailable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_9),
                      _createElementVNode("img", {
                        src: card.img,
                        alt: card.model
                      }, null, 8, _hoisted_14)
                    ]))
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _hoisted_15,
    _createElementVNode("section", _hoisted_16, [
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("figure", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("video", {
              autoplay: "",
              playsinline: "",
              loop: "",
              muted: "",
              ref_key: "vid1",
              ref: vid1
            }, _hoisted_24, 512)
          ])
        ]),
        _createElementVNode("figure", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("video", {
              autoplay: "",
              playsinline: "",
              loop: "",
              muted: "",
              ref_key: "vid2",
              ref: vid2
            }, _hoisted_29, 512)
          ])
        ]),
        _createElementVNode("figure", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("video", {
              autoplay: "",
              playsinline: "",
              loop: "",
              muted: "",
              ref_key: "vid3",
              ref: vid3
            }, _hoisted_34, 512)
          ])
        ])
      ]),
      _hoisted_35
    ])
  ], 512))
}
}

})